import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledGridColumn from "./GridColumn.styles";
import useViewport from "../../../../hooks/useViewport";
import { GridColumnProps, GridColumnSpanOptions } from "./GridColumn.types";
import { useContext } from "react";
import { ViewportSsrContext } from "../../../../hooks/useViewport/ViewportSsrContext";

const resolveModifier = (
	...values: (GridColumnSpanOptions | undefined)[]
): GridColumnSpanOptions => {
	const found = values.find(
		(value: GridColumnSpanOptions | undefined) => value !== undefined
	);
	return found !== undefined ? found : 12;
};

const GridColumn: React.FC<GridColumnProps> = ({
	className,
	xs,
	sm,
	md,
	lg,
	xl,
	xxl,
	...props
}) => {
	const block = new BemIt("GridColumn");
	const vp = useViewport();
	const contextBreakpoint = useContext(ViewportSsrContext);

	let modifier: GridColumnSpanOptions = 0;
	if (contextBreakpoint) {
		// If context breakpoint is set then we should prioritise this because it's an indication of SSR.

		if (contextBreakpoint === "xs") {
			modifier = resolveModifier(xs);
		} else if (contextBreakpoint === "sm") {
			modifier = resolveModifier(sm, xs);
		} else if (contextBreakpoint === "md") {
			modifier = resolveModifier(md, sm, xs);
		} else if (contextBreakpoint === "lg") {
			modifier = resolveModifier(lg, md, sm, xs);
		} else if (contextBreakpoint === "xl") {
			modifier = resolveModifier(xl, lg, md, sm, xs);
		} else if (contextBreakpoint === "xxl") {
			modifier = resolveModifier(xxl, xl, lg, md, sm, xs);
		}
	} else {
		// Otherwise, assume we're on the client and use the viewport result...

		if (vp.is.xs) {
			modifier = resolveModifier(xs);
		} else if (vp.is.sm) {
			modifier = resolveModifier(sm, xs);
		} else if (vp.is.md) {
			modifier = resolveModifier(md, sm, xs);
		} else if (vp.is.lg) {
			modifier = resolveModifier(lg, md, sm, xs);
		} else if (vp.is.xl) {
			modifier = resolveModifier(xl, lg, md, sm, xs);
		} else if (vp.is.xxl) {
			modifier = resolveModifier(xxl, xl, lg, md, sm, xs);
		}
	}

	return (
		<StyledGridColumn
			className={addClass(className).after(block.mod(modifier.toString()))}
			viewport={vp}
			suppressHydrationWarning
			{...props}
		>
			{props.children}
		</StyledGridColumn>
	);
};

export default GridColumn;
